import { PIXEL_COEFFICIENT, USER_CHARTS_WORK_WIDTH_MM } from 'containers/PdfContainer/constants';

export default function getHazardRatioChartBlockWidths(programLength) {
  const slotWidth = (USER_CHARTS_WORK_WIDTH_MM
    / (programLength >= 10 ? programLength : 10)) * PIXEL_COEFFICIENT;
  const barWidth = slotWidth / 3;
  return [slotWidth, barWidth];
}
